
export { default as evolve } from "./evolve.js"
export { default as mergeLeft } from "./mergeLeft.js"
export { default as pipe } from "./pipe.js"